import { AuthenticationResult, EventType, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ReactNode, useEffect, useState } from 'react';
import { setMsalForRequests } from '../api/axios.ts';
import { prefetchUsers } from '../api/created/users.ts';
import { getGetEntraIdConfigQueryKey } from '../api/generated/config-controller/config-controller.ts';
import { EntraIdConfigDto } from '../api/generated/model';
import { putWhoami } from '../api/generated/user-controller/user-controller.ts';

export function AuthenticationGate({ children }: { children: ReactNode }) {
  const [msal, setMsal] = useState<PublicClientApplication | null>(null);
  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_BASE_URL ?? ''}${getGetEntraIdConfigQueryKey()[0]}`)
      .then((response) => response.json())
      .then((config: EntraIdConfigDto) => {
        const msalConfig = {
          auth: {
            clientId: config.clientId,
            authority: config.authority,
            redirectUri: '/',
          },
          cache: {
            cacheLocation: 'localStorage',
          },
        };
        const msalInstance = new PublicClientApplication(msalConfig);

        msalInstance
          .initialize()
          .then(() => {
            if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
              msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
            }

            if (msalInstance.getActiveAccount()) {
              void prefetchUsers();
            }

            msalInstance.enableAccountStorageEvents();

            msalInstance.addEventCallback((event) => {
              if (event.eventType === EventType.LOGIN_SUCCESS) {
                msalInstance.setActiveAccount((event.payload as AuthenticationResult).account);
                putWhoami()
                  .then(() => prefetchUsers())
                  .catch(() => console.log('failed to report logged in user to backend'));
              }
            });

            setMsal(msalInstance);
            setMsalForRequests(msalInstance);
          })
          .catch(() => console.log('Failed to initialize entraid'));
      })
      .catch(() => console.log('Failed to get entraid config'));
  }, []);

  return msal && <MsalProvider instance={msal}>{children}</MsalProvider>;
}
